
    (function(){
      const root      = document.getElementById('sc-template--19513287016490__wj_carousel_white_sync');
      const viewport  = root.querySelector('.sc-viewport');
      const panelsEl  = root.querySelector('.sc-panels');
      const allPanels = Array.from(root.querySelectorAll('.sc-panel'));
      const titleEl   = root.querySelector('.sc-title');
      const subtitle  = root.querySelector('.sc-subtitle');
      const allRadios = Array.from(root.querySelectorAll('input[name="slide-template--19513287016490__wj_carousel_white_sync"]'));
      const allBullets= Array.from(root.querySelectorAll('.sc-bullet'));
      const nextBtn   = root.querySelector('.sc-next');
      const autoplayMs= 4000;
      const autoplay  = true;
      let timer;
      let visible = false;

      /* ── Visible-only arrays (rebuilt on color switch) ── */
      let vPanels = allPanels.slice();
      let vRadios = allRadios.slice();
      let curIdx  = 0;                       // index within vPanels / vRadios

      panelsEl.addEventListener('dragstart', e => e.preventDefault());
      root.querySelectorAll('img, picture, source').forEach(el => el.setAttribute('draggable','false'));

      const gap    = () => parseFloat(getComputedStyle(panelsEl).gap || '0') || 0;
      const slideW = () => viewport.clientWidth;

      /* Transform is now based on curIdx within visible slides only */
      const baseX  = () => -(curIdx * (slideW() + gap()));
      const setX   = (x = baseX()) => panelsEl.style.transform = `translateX(${x}px)`;

      function markActive(i){
        allPanels.forEach(p => p.classList.remove('sc-active'));
        if (vPanels[i]) vPanels[i].classList.add('sc-active');
      }

      function swapText(el, newText){
        if (el.textContent === newText) return;
        el.classList.remove('sc-enter');
        el.classList.add('sc-leave');
        el.addEventListener('animationend', function h(){
          el.removeEventListener('animationend', h);
          el.textContent = newText;
          el.classList.remove('sc-leave');
          void el.offsetWidth;
          el.classList.add('sc-enter');
        }, {once:true});
      }
      function updateTitle(i){
        swapText(titleEl, vPanels[i]?.dataset.title || '');
      }
      function updateSubtitle(i){
        swapText(subtitle, vPanels[i]?.dataset.subtitle || '');
      }

      function goTo(i){
        if (!vRadios.length) return;
        i = ((i % vRadios.length) + vRadios.length) % vRadios.length;
        curIdx = i;
        /* Uncheck all, then check the right one */
        allRadios.forEach(r => r.checked = false);
        vRadios[i].checked = true;
        setX(); markActive(i); updateTitle(i); updateSubtitle(i);
      }
      const next = () => goTo(curIdx + 1);
      const prev = () => goTo(curIdx - 1);

      function stopAutoplay(addPausedClass = true){
        clearInterval(timer);
        if (addPausedClass) root.classList.add('sc-paused');
      }
      function startAutoplay(){
        stopAutoplay(false);
        if (!autoplay || !visible) { root.classList.add('sc-paused'); return; }
        root.classList.remove('sc-paused');
        timer = setInterval(next, autoplayMs);
      }
      function maybeStartAutoplay(){
        if (autoplay && visible) startAutoplay(); else stopAutoplay(true);
      }

      const io = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.6;
          maybeStartAutoplay();
        });
      }, { threshold: [0, 0.25, 0.6, 1] });
      io.observe(root);

      window.addEventListener('load', ()=>{
        /* Initial filter will handle first render via DOMContentLoaded below */
      });
      window.addEventListener('resize', ()=>{ clearTimeout(root.__rsz); root.__rsz=setTimeout(()=>{ setX(); },100); });

      /* Bullet click → find visible index and goTo */
      allBullets.forEach(b => {
        b.addEventListener('click', () => {
          const radioId = b.getAttribute('for');
          const ri = vRadios.findIndex(r => r.id === radioId);
          if (ri >= 0) { goTo(ri); maybeStartAutoplay(); }
        });
      });
      /* Prevent default radio change from old handler; we handle via bullet click */
      allRadios.forEach(r => {
        r.addEventListener('change', e => {
          /* If changed externally (CSS :checked), sync curIdx */
          const ri = vRadios.indexOf(r);
          if (ri >= 0 && ri !== curIdx) { goTo(ri); maybeStartAutoplay(); }
        });
      });

      if (nextBtn) nextBtn.addEventListener('click', ()=>{ next(); maybeStartAutoplay(); });

      /* ── Drag / swipe ── */
      let dragging=false, startX=0, startY=0, startT=0, lock=null, startOffset=0;

      function onDown(e){
        if (e.buttons !== undefined && e.buttons !== 1 && e.pointerType === 'mouse') return;
        dragging=true; lock=null;
        startX=e.clientX; startY=e.clientY; startT=performance.now();
        startOffset=baseX();
        panelsEl.classList.add('sc-dragging');
        viewport.classList.add('is-dragging');
        stopAutoplay();
        panelsEl.setPointerCapture?.(e.pointerId);
      }
      function onMove(e){
        if (!dragging) return;
        const dx=e.clientX-startX, dy=e.clientY-startY;
        if (lock==null && (Math.abs(dx)>8 || Math.abs(dy)>8)) lock = Math.abs(dx)>=Math.abs(dy)?'x':'y';
        if (lock==='y'){ onUp(e,true); return; }
        if (lock==='x'){ panelsEl.style.transform = `translateX(${startOffset + dx}px)`; e.preventDefault?.(); }
      }
      function onUp(e, cancel=false){
        if (!dragging) return;
        dragging=false;
        panelsEl.classList.remove('sc-dragging');
        viewport.classList.remove('is-dragging');
        panelsEl.releasePointerCapture?.(e.pointerId);
        if (cancel){ setX(); maybeStartAutoplay(); return; }

        const dx=e.clientX-startX, dt=Math.max(1, performance.now()-startT), vx=dx/dt;
        const threshold = slideW()*0.15, speed=0.35;
        if (dx<=-threshold || vx<=-speed) next();
        else if (dx>=threshold || vx>=speed) prev();
        else setX();

        maybeStartAutoplay();
      }
      viewport.addEventListener('pointerdown', onDown, {passive:true});
      window.addEventListener('pointermove', onMove, {passive:false});
      window.addEventListener('pointerup', onUp, {passive:true});
      window.addEventListener('pointercancel', e=>onUp(e,true), {passive:true});

      /* ── Color-group switching ── */
      document.addEventListener('wj-color-switch', function(e) {
        if (e.detail && typeof e.detail.index === 'number') {
          const cg = String(e.detail.index);

          /* 1. Show/hide panels, radios, bullets */
          allPanels.forEach(p => {
            p.style.display = p.dataset.colorGroup === cg ? '' : 'none';
            p.classList.remove('sc-active');
          });
          allRadios.forEach(r => {
            r.style.display = r.dataset.colorGroup === cg ? '' : 'none';
            r.checked = false;
          });
          allBullets.forEach(b => {
            b.style.display = b.dataset.colorGroup === cg ? '' : 'none';
          });

          /* 2. Rebuild visible arrays */
          vPanels = allPanels.filter(p => p.dataset.colorGroup === cg);
          vRadios = allRadios.filter(r => r.dataset.colorGroup === cg);

          /* 3. Reorder: move visible panels to front via CSS order */
          let vi = 0;
          allPanels.forEach(p => {
            p.style.order = p.dataset.colorGroup === cg ? vi++ : 999;
          });

          /* 4. Go to first visible slide */
          goTo(0);
          maybeStartAutoplay();
        }
      });

      /* ── Init: show only color group 0 ── */
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
          const colorTabs = Array.from(document.querySelectorAll('.wj-color-nav-item'));
          const selectedIndex = colorTabs.findIndex((item) => item.getAttribute('aria-pressed') === 'true');
          document.dispatchEvent(new CustomEvent('wj-color-switch', {
            detail: { index: Math.max(0, selectedIndex), source: 'init' }
          }));
        }, 100);
      });

    })();
  
